import { render } from "./GroupTable.vue?vue&type=template&id=05a0cd8c&scoped=true"
import script from "./GroupTable.vue?vue&type=script&lang=js"
export * from "./GroupTable.vue?vue&type=script&lang=js"

import "./GroupTable.vue?vue&type=style&index=0&id=05a0cd8c&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a0cd8c"]])

export default __exports__